import { useEffect, useState } from 'react';

import { Content as NormalContent } from './content/normal';
import { Content as NormalPiContent } from './content/normal-pi';
import { Content as TacticalAdsContent } from './content/tactical-ads';
import { Footer } from './footer';
import styles from './styles.module.scss';
import type { Component } from './types';

export const Step: Component = ({
  dealer,
  description,
  endsOn,
  image,
  link,
  models,
  postedOn,
  promoType,
  id,
  isUserLogin,
  isAllModels,
  isAddToAlert,
  make,
  onAlertAdd,
  onErrorReport,
  setOpen,
}) => {
  const [whatsAppLink, setWhatAppLink] = useState('');

  const whatsAppMessage = 'Hi, I\'m interested!';
  const encodedUrl = encodeURIComponent(whatsAppMessage);

  useEffect(() => {
    if (dealer.type === 'ad') {
      if (dealer.contactNumbers && dealer.contactNumbers.length >= 2) {
        setWhatAppLink(`https://api.whatsapp.com/send?phone=65${dealer.contactNumbers[1]}&text=${encodeURIComponent(link)}%0A%0A${encodedUrl}`);
      } else {
        setWhatAppLink('');
      }
    } else {
      setWhatAppLink(`https://api.whatsapp.com/send?phone=65${dealer.whatsAppNumber}&text=${encodeURIComponent(link)}%0A%0A${encodedUrl}`);
    }
  }, [dealer, link, encodedUrl]);

  return (
    <div
      className={styles.containerRoot}>
      <div
        className={styles.containerHeader}>
        Promotion
      </div>
      <div
        className={styles.containerContent}>
        {
          promoType === 'normal_promo' && dealer.type === 'ad' && (
            <NormalContent
              dealer={dealer}
              description={description}
              endsOn={endsOn}
              image={image}
              isAllModels={isAllModels}
              link={link}
              make={make}
              models={models}
              postedOn={postedOn}
              setOpen={setOpen}
              onErrorReport={onErrorReport} />
          )
        }
        {
          promoType === 'normal_promo' && dealer.type === 'pi' && (
            <NormalPiContent
              dealer={dealer}
              description={description}
              endsOn={endsOn}
              image={image}
              link={link}
              models={models}
              postedOn={postedOn}
              setOpen={setOpen}
              onErrorReport={onErrorReport} />
          )
        }
        {
          promoType === 'tactical_ads' && (
            <TacticalAdsContent
              dealer={dealer}
              description={description}
              endsOn={endsOn}
              id={id}
              isAllModels={isAllModels}
              link={link}
              make={make}
              models={models}
              postedOn={postedOn}
              setOpen={setOpen}
              onErrorReport={onErrorReport} />
          )
        }
      </div>
      <div className={styles.containerFooter}>
        <Footer
          endsOn={endsOn}
          isAddToAlert={isAddToAlert}
          isUserLogin={isUserLogin}
          postedOn={postedOn}
          whatsAppLink={whatsAppLink}
          onAlertAdd={onAlertAdd} />
      </div>
    </div>
  );
};
